<template>
  <CardContainer>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <CardTitle>Sign in to your account</CardTitle>
        </v-flex>
      </v-layout>

      <form novalidate @submit.prevent="signin">
        <v-layout row wrap>
          <v-flex xs12>
            <BaseAlert
              v-if="showPasswordResetCallout"
              :hg-value="true"
              hg-type="success"
              ref="password-changed-alert">
              Password successfully changed
            </BaseAlert>
            <BaseAlert
              :hg-value="apiError"
              hg-type="error"
              ref="api-error-alert">
              Unable to sign in. Either this username or password is incorrect,
              or your password has expired.
              <router-link
                :to="{ name: 'forgotpassword' }"
                ref="forgot-password-link">
                Reset your password
              </router-link>
            </BaseAlert>
          </v-flex>

          <v-flex xs12>
            <v-text-field
              label="Username"
              v-model="model.username"
              name="UserName"
              autocomplete="username"
              v-validate="'required'"
              outline />
          </v-flex>

          <v-flex xs12>
            <PasswordField
              v-model="model.password"
              v-validate="'required'"
              autocomplete="password"
              label="Password"
              name="Password"
              type="password"
              outline />
          </v-flex>

          <v-flex xs12>
            <BaseButton
              :disabled="apiLoading"
              :hgLabel="apiLoading ? 'Signing In' : 'Sign In'"
              type="submit" />
          </v-flex>

        </v-layout>
      </form>
    </v-container>
    <template v-slot:subcontent>
      <v-flex xs12 class="forgot-password-container">
        <span class="d-block mb-2">Are you having trouble signing in?</span>
        <BaseButton
          :disabled="apiLoading"
          :inline="true"
          level="secondary">
          <router-link
            :to="{ name: 'forgotpassword' }"
            class="forgot-password-link"
            ref="forgot-password-link">
            Reset your password
          </router-link>
        </BaseButton>
      </v-flex>
    </template>
  </CardContainer>
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';

import CardContainer from '@/components/CardContainer.vue';
import CardTitle from '@/components/CardTitle.vue';

const { BaseAlert, BaseButton, PasswordField } = Components;

export default {
  components: {
    BaseAlert,
    BaseButton,
    CardContainer,
    CardTitle,
    PasswordField,
  },
  props: {
    passwordReset: {
      type: String,
      default: '',
    },
    reDir: {
      type: String,
      default: '',
    },
    reDirRouteName: {
      type: String,
      default: '',
    },
    existingQueryParams: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      apiLoading: false,
      apiError: false,
      model: {
        username: '',
        password: '',
      },
    };
  },
  mounted() {
    this.$store.dispatch('Person/getLoggedInPerson')
      .then(res => this.performPersonRedirect(res))
      .catch(() => {
        // eat the error, we anticipate a possible 401/3
      });
  },
  created() {
    const previousHost = document.referrer ? new URL(document.referrer).host : '';
    const currentHost = window.location.host;

    if (!this.existingQueryParams && previousHost === currentHost) {
      // eslint-disable-next-line no-console
      console.log('No query params found. Redirecting...');
      window.location = new URL(process.env.VUE_APP_PRICING_URL);
    }
  },
  computed: {
    showPasswordResetCallout() {
      return this.passwordReset === 'true';
    },
  },
  methods: {
    performPersonRedirect(res) {
      const domainRegex = /^(https?):\/\/([a-z]+([.-][a-z]+)?\.homegauge\.[a-z]+(:\d{1,4})?)/;

      if (this.reDirRouteName && this.existingQueryParams) {
        this.$router.push({
          path: this.reDirRouteName,
          query: {
            redirectParams: this.existingQueryParams,
          },
        });
      } else if (this.reDir && domainRegex.test(this.reDir)) {
        window.location = this.reDir;
      } else {
        window.location = res?.defaultUrl ?? 'https://homegauge.com';
      }
    },
    async signin() {
      this.apiError = false;
      this.apiLoading = true;

      const payload = {
        username: this.model.username.trim(),
        password: this.model.password.trim(),
      };

      try {
        await this.$store.dispatch('Auth/loginUser', payload);

        const loggedInUser = await this.$store.dispatch('Person/getLoggedInPerson');
        this.performPersonRedirect(loggedInUser);
      } catch (err) {
        this.apiError = true;
      }

      this.apiLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  &-link {
    text-decoration: none;
    color: #2D2D2D;
  }
  &-container {
    text-align: center;
    padding: 20px 0;
    border-bottom: 1px solid #D3D3D3;
  }
}
</style>
